var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1280.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4250 8956 l0 -2813 -61 -7 c-34 -3 -526 -6 -1093 -6 l-1031 -1 66 -62 c36 -34 756 -714 1600 -1512 844 -797 1820 -1719 2169 -2049 349 -329 667 -630 705 -668 l70 -68 230 217 c1454 1373 3719 3512 4012 3790 l373 353 -1090 0 -1090 0 0 2820 0 2820 -2430 0 -2430 0 0 -2814z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientArrowDown);
export default __webpack_public_path__ + "static/media/gradient-arrow-down.818ab3d84c23d41fb0388974dfc4a78a.svg";
export { ForwardRef as ReactComponent };